module.exports = __webpack_public_path__ + "img/icon-live.5a654bf.webp";